<template>
  <ul
    class="header-dropdown-menu"
    role="menu"
    :hidden="!expanded"
  >
    <li
      role="none"
      v-for="(item, i) in menu"
      :key="i"
    >
      <router-link
        class="header-dropdown-menu__item"
        role="menuitem"
        rel="noopener"
        :tabindex="tabindex"
        :to="item.to"
        @click.native="hideMenu"
      >
        <img
          v-if="item.icon"
          :src="item.icon"
          alt="Icon"
          aria-hidden="true"
          width="24"
          height="24"
        >
        {{ item.name }}
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'HeaderMenu',
  props: {
    menu: {
      type: Array,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    tabindex() {
      return this.expanded ? 0 : -1;
    },
  },
  methods: {
    hideMenu() {
      this.$emit('hide-menu');
    },
  },
};
</script>

<style lang="scss">
.header-dropdown-menu {
  position: relative;
  padding: 0.5rem;

  background-color: var(--gray-1);
  border-radius: var(--border-radius);

  &::before {
    content: "";

    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%) rotateZ(45deg);

    width: 13px;
    height: 13px;

    background-color: var(--gray-1);
    border: 1px solid var(--muted);
    border-right-color: transparent;
    border-bottom-color: transparent;
  }

  &__item {
    display: flex;
    align-items: center;
    padding: 13px 1rem;

    color: var(--background);

    &:hover,
    &:focus {
      background-color: var(--primary);
      border-radius: var(--border-radius);
    }

    img {
      &:first-child {
        margin-right: 1.5rem;
      }
    }
  }
}
</style>
